import useBundleTranslation from 'i18n';
import { Button, DialogActions } from '@mui/material';
import React from 'react';

export default function FormConfirmationFooter({
    onConfirm,
    onCancel,
}: {
    onConfirm: () => void;
    onCancel: () => void;
}) {
    const { t } = useBundleTranslation();
    return (
        <DialogActions
            sx={{
                justifyContent: 'normal',
                flexWrap: 'wrap',
                display: 'flex',
                padding: '16px 24px',
                borderTop: '1px solid #e0e0e0',
                margin: '16px -24px -16px',
            }}
        >
            <Button
                variant={'contained'}
                onClick={onConfirm}
                className={'popup-button--ok'}
                data-test={'confirm_ok_button'}
            >
                {t('ok')}
            </Button>

            <Button
                data-test={'confirm_cancel_button'}
                variant="outlined"
                color="neutral"
                onClick={onCancel}
                className={'popup-button--cancel'}
            >
                {t('cancel')}
            </Button>
        </DialogActions>
    );
}
